import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
import { EnumSignType } from '@/libs/twcaHelper';

/**
 * @todo Api 傳入值
 */
export interface RiskWarningContractPostBackReq {
    data: string;
    signType: EnumSignType.EsunMCA;
    esunMCA_Base64DataPlaintext: string;
    esunMCA_Signed: string;
    esunMCA_Seq: string;
    recTerms: string;
}
/**
 * @todo 契約2 PostBack
 */
const ContractConfirmPostBack = (postbackData: RiskWarningContractPostBackReq): Promise<GeneralResp> => {
    const url = RouteUrlList.API_ContractConfirmPostBack.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, postbackData, config).then((res: AxiosResponse<GeneralResp>) => {
        return res.data;
    });
};

export default ContractConfirmPostBack;
